export { EventCard, type EventCardProps } from "./EventCard"
